import type { ShouldRevalidateFunction } from 'react-router-dom';

const sameValues = (a: ReadonlyArray<string>, b: ReadonlyArray<string>): boolean =>
  a.length === b.length && a.every((value, index) => value === b[index]);

/** A route's loader re-runs on an address change only when one of `keys` changed. */
export function revalidateOn(keys: ReadonlyArray<string>): ShouldRevalidateFunction {
  return ({ currentUrl, nextUrl, defaultShouldRevalidate }) => {
    if (currentUrl.pathname !== nextUrl.pathname) return defaultShouldRevalidate;

    if (currentUrl.search === nextUrl.search) return defaultShouldRevalidate;

    return keys.some((key) => !sameValues(currentUrl.searchParams.getAll(key), nextUrl.searchParams.getAll(key)));
  };
}
